/**
 * Event bus dla globalnego stanu koszyka (bez React Context).
 *
 * `WCard` w headerze i `ProductCard`/`CShopCategoryArticle` w liscie/karcie
 * produktu siedza w roznych poddrzewach - nie mozemy przekazac callbacku propem.
 * Zamiast wprowadzac context provider (koszyk uzywany na wiekszosci stron =
 * duzo zbednych renderow) uzywamy natywnego CustomEvent na window.
 *
 * Nazwa eventu prefixowana `imperial:` zeby uniknac kolizji z eventami hostow
 * embedujacych aplikacje (np. iframe w admin overlays).
 */

export const CART_OPEN_EVENT = "imperial:cart:open";

export function dispatchCartOpen(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CART_OPEN_EVENT));
}
